import { Injectable } from '@angular/core';
import { CommentApi } from './../api/comment.api';
import { EdlComment } from './../model/comment.model';

@Injectable()
export class CommentService {
  constructor(private commentApi: CommentApi) { }

  getCommentsForObservation = (observationType: number, observationId: string) =>
    this.commentApi.getCommentsForObservation(observationType, observationId);

  saveComment = (comment: EdlComment) =>
    this.commentApi.saveComment(comment);

  deleteComment = (comment: EdlComment) =>
    this.commentApi.deleteComment(comment);

  publishAllComments = (observationType: number, observationId: string) =>
    this.commentApi.publishAllComments(observationType, observationId);
}
